import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "FormatControlsSections"*/ './lazyIndex'),
    { name: 'FormatControlsSections' }
);

export const lazyGetUndoRedoSections: LazyImport<
    typeof lazyIndex.getUndoRedoSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getUndoRedoSections);
export const lazyGetCutCopyPasteSections: LazyImport<
    typeof lazyIndex.getCutCopyPasteSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getCutCopyPasteSections);
export const lazyGetAlignSections: LazyImport<
    typeof lazyIndex.getAlignSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getAlignSections);
export const lazyGetChangeCaseSections: LazyImport<
    typeof lazyIndex.getChangeCaseSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getChangeCaseSections);
export const lazyGetFontColorSections: LazyImport<
    typeof lazyIndex.getFontColorSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getFontColorSections);
export const lazyGetFontBackColorSections: LazyImport<
    typeof lazyIndex.getFontBackColorSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getFontBackColorSections);
export const lazyGetStyleSections: LazyImport<
    typeof lazyIndex.getStyleSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getStyleSections);
export const lazyGetSpacingSections: LazyImport<
    typeof lazyIndex.getSpacingSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getSpacingSections);
export const lazyGetBorderSections: LazyImport<
    typeof lazyIndex.getBorderSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getBorderSections);
export const lazyGetShadowSections: LazyImport<
    typeof lazyIndex.getShadowSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getShadowSections);
export const lazyGetPictureSizeSections: LazyImport<
    typeof lazyIndex.getPictureSizeSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getPictureSizeSections);
export const lazyGetTableAlignSections: LazyImport<
    typeof lazyIndex.getTableAlignSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getTableAlignSections);
export const lazyGetTableBorderWeightSections: LazyImport<
    typeof lazyIndex.getTableBorderWeightSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getTableBorderWeightSections);
export const lazyGetTableBorderColorSections: LazyImport<
    typeof lazyIndex.getTableBorderColorSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getTableBorderColorSections);
export const lazyGetApplyTableBorderSections: LazyImport<
    typeof lazyIndex.getApplyTableBorderSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getApplyTableBorderSections);
export const lazyGetCellShadingSections: LazyImport<
    typeof lazyIndex.getCellShadingSections,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getCellShadingSections);

export const lazyGetTableStylesGalleryMenuDefinition: LazyImport<
    typeof lazyIndex.getTableStylesGalleryMenuDefinition,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getTableStylesGalleryMenuDefinition);
